import { StructureInfo } from './structure-info';

export class StructureList {
  public text = '';
  public webDokuId = '';
  public data: StructureInfo[] = [];
  public pathInfo = '';
  public searchText = '';
  public isFlat = false;
  public get moreThanOneItemAvailable(): boolean {
    return this.data != undefined && this.data.length > 1;
  }

  public static emptyList(webDokuId: string) {
    const empty = new StructureList();
    empty.webDokuId = webDokuId;
    return empty;
  }
}
